import { OUTSTANDING_INQUIRY_STATUSES } from "../../../../../api/supplierInquiriesApi"
import {
  CoverageBoard,
  type CoverageTileDef,
} from "../../../../shared/dashboard/CoverageBoard"
import type { DashboardWidgetProps } from "../widgetRegistry"

const MC_BASE = "/material-compliance"

const TILES: CoverageTileDef<DashboardWidgetProps["stats"]>[] = [
  {
    labelKey: "MC_SSD_TILE_IN_REVIEW",
    subKey: "MC_SSD_TILE_IN_REVIEW_SUB",
    value: (s) => s.statusBuckets.inReview,
    to: `${MC_BASE}/supplier-studio/declarations?lifecycle=pending,processing,ready`,
  },
  {
    labelKey: "MC_SSD_TILE_AWAITING",
    subKey: "MC_SSD_TILE_AWAITING_SUB",
    value: (s) => s.statusBuckets.awaiting,
    // derived from the shared OUTSTANDING_INQUIRY_STATUSES constant, which
    // mirrors the awaiting CTE (TUR-1520)
    to: `${MC_BASE}/supplier-studio/inquiry?status=${OUTSTANDING_INQUIRY_STATUSES.join(",")}`,
  },
  {
    labelKey: "MC_SSD_TILE_OUTDATED",
    subKey: "MC_SSD_TILE_OUTDATED_SUB",
    value: (s) => s.statusBuckets.outdated,
    // F2: the tile's count comes from the supplier-bucket `outdated` CTE
    // (mc_supplier_dashboard_repository), NOT the declaration-lifecycle
    // predicate `lifecycle=expiring` used to link here — the two disagreed in
    // both directions. Links to the master-data supplier list's own bucket
    // filter, which shares the same CTE.
    to: `${MC_BASE}/master-data/suppliers?bucket=outdated`,
  },
  {
    labelKey: "MC_SSD_TILE_NEVER_ASKED",
    subKey: "MC_SSD_TILE_NEVER_ASKED_SUB",
    value: (s) => s.statusBuckets.neverAsked,
    // F2: links to the master-data supplier list's own bucket filter, which
    // shares the tile's never_asked CTE (same pattern as the Outdated tile).
    to: `${MC_BASE}/master-data/suppliers?bucket=never_asked`,
    critical: true,
    extraSubs: [
      {
        key: "MC_SSD_TILE_NEVER_ASKED_NO_CONTACT",
        count: (s) => s.statusBuckets.neverAsked.noContact,
      },
      {
        key: "MC_SSD_TILE_NEVER_ASKED_BOUNCED",
        count: (s) => s.statusBuckets.neverAsked.bounced,
      },
    ],
  },
]

export function CoverageWidget({ stats }: DashboardWidgetProps) {
  return (
    <CoverageBoard
      stats={stats}
      primary={{
        value: (s) => s.articles,
        labelKey: "MC_SSD_COV_ARTICLES",
        popLabelKey: "MC_SSD_POP_ARTICLES",
      }}
      secondary={{
        value: (s) => s.suppliers,
        labelKey: "MC_SSD_COV_SUPPLIERS",
        popLabelKey: "MC_SSD_POP_SUPPLIERS",
      }}
      popAbsoluteKey="MC_SSD_POP_ABSOLUTE"
      tilePopLabelKey="MC_SSD_POP_SUPPLIERS"
      tiles={TILES}
    />
  )
}
